export const COLORS = {
	RED: '#F44336',
	YELLOW: '#FFC107',
	GREEN: '#4dbd74',
    BLUE: '#386FA4',
	BLACK: '#000000'
}